import { __awaiter, __decorate, __metadata } from "tslib";
import { Mutation, VuexModule, Action, Module } from 'vuex-module-decorators';
import ApiService from '@/core/services/ApiService';
import moment from 'moment';
import store from '@/store';
import { isObject } from 'lodash';
import { MutationsGeneral } from '@/store/enums/pscm/migo/generalEnum';
import { hideModal } from '@/core/helpers/dom';
let transactionTpModule = class transactionTpModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.isOnImport = false;
        this.tempId = null;
        this.headerId = 0;
        this.isTpSearched = false;
        this.viewHeader = {};
        this.tabConditionTp = 'header';
        this.typeOfDocument = '';
        this.listFields = {
            enableField: {
                transactionType: false,
                documentDate: false,
                materialSlip: false,
                postingDate: false,
                docHeaderText: false,
                attachments: false,
                movementType: false,
                specialStock: false
            },
            visibleField: {
                transactionType: false,
                documentDate: false,
                materialSlip: false,
                postingDate: false,
                docHeaderText: false,
                attachments: false,
                movementType: false,
                specialStock: false
            },
            mandatory: {
                transactionType: false,
                documentDate: false,
                materialSlip: false,
                postingDate: false,
                docHeaderText: false,
                attachments: false,
                movementType: false,
                specialStock: false
            }
        };
        this.tpHeaderForm = {
            typeReceipt: '',
            postType: '',
            movType: '',
            indexReceipt: 0,
            indexPostType: 0,
            indexMvType: 0,
            materialDocumentYear: moment(new Date()).format('DD MMM YYYY'),
            matDocYear: null,
            typeOrder: null,
            orderNumber: null,
            reservationNumber: null,
            noPurchaseOrder: null,
            poItem: null,
            itemNo: '',
            documentDate: moment(new Date()).format('DD MMM YYYY'),
            deliveryNote: null,
            supplier: null,
            postingDate: moment(new Date()).format('DD MMM YYYY'),
            billOfLading: null,
            headerText: null,
            giUploadAttachment: [],
            vendorName: null,
            vendorNumber: null,
            submitClick: false,
            uploadTp: [],
            movementType: null,
            specialStock: null,
            specialStockDescription: null,
            documentStatus: '',
            documentStatusCode: '',
            documentType: '',
            documentTypeCode: '',
            bSpaceMatDoc: '',
            materialDocument: '',
            hasMatDoc: null,
            materialSlip: '',
            isCancelDoc: false,
            materialDocumentRead: null
        };
        this.tpItemForm = {
            documentType: '',
            viewType: '',
            current: {},
            list: [],
            totalRecords: 0,
            totalPages: 0
        };
        this.tpItemSelected = {
            current: {},
            list: [],
            selectedItem: [],
            isAllSelected: false
        };
        this.tempTpOther = [];
        this.errorListTpOther = [
            {
                materialDesc: false,
                qty: false,
                slocCode: false,
                vendorCode: false,
                movementType: false,
                specialStock: false,
                slocCodeTp: false
            }
        ];
        this.errorListsTp = {
            postClicked: false,
            requiredAll: false,
            snNotSame: false,
            listItem: [],
            listHeader: []
        };
        this.tpLookup = {
            typeorder: [
                {
                    lookupVal: 'Order',
                    lookupText: 'Order',
                    lookupData: null,
                    lookupValText: 'Order | Order'
                },
                {
                    lookupVal: 'Reservation',
                    lookupText: 'Reservation',
                    lookupData: null,
                    lookupValText: 'Reservation | Reservation'
                },
                {
                    lookupVal: 'Other',
                    lookupText: 'Other',
                    lookupData: null,
                    lookupValText: 'Other | Other'
                },
                {
                    lookupVal: 'PurchaseOrder',
                    lookupText: 'Purchase Order',
                    lookupData: null,
                    lookupValText: 'PurchaseOrder | Purchase Order'
                }
            ],
            transactionType: [],
            stockType: [],
            delCompleteInd: [],
            sloc: [],
            slocHead: [],
            mvtype: [],
            specialstock: [],
            valtype: [],
            vendor: [],
            reasonMv: [],
            plant: [],
            material: [],
            costCenter: []
        };
        this.headerErrorTp = {
            documentDate: false,
            materialSlip: false,
            postingDate: false,
            docHeaderText: false
        };
        this.importFileTp = {
            files: null,
            store: [],
            isError: false,
            isImported: false,
            isAllowImport: true,
            isOnAsync: false
        };
        this.nextPrevItems = {
            list: []
        };
    }
    get getIsOnImportTp() {
        return this.isOnImport;
    }
    get getTypeOfDocumentTp() {
        return this.typeOfDocument;
    }
    get getNextPrevItemsTpMigo() {
        return this.nextPrevItems;
    }
    get getImportFileTp() {
        return this.importFileTp;
    }
    get getTpLookup() {
        return this.tpLookup;
    }
    get getTpHeaderForm() {
        return this.tpHeaderForm;
    }
    get getTpItemForm() {
        return this.tpItemForm;
    }
    get getTpItemSelected() {
        return this.tpItemSelected;
    }
    get getTempTpOther() {
        return this.tempTpOther;
    }
    get getErrorListTpOther() {
        return this.errorListTpOther;
    }
    get getErrorListsTp() {
        return this.errorListsTp;
    }
    get getHeaderFieldsSetting() {
        return this.listFields;
    }
    ['setPlantListTp'](data) {
        this.tpItemForm.list[data.index].whereTab.plantCode = data.plantCodeValue;
        this.tpItemForm.list[data.index].whereTab.plantName = data.plantNameValue;
        this.tpItemForm.list[data.index].transferPostingTab.from.plantCode =
            data.plantCodeValue;
        this.tpItemForm.list[data.index].transferPostingTab.from.plantName =
            data.plantNameValue;
    }
    ['setIsOnImportTp'](data) {
        this.isOnImport = data;
    }
    ['setClearSelectedItemTp']() {
        this.tpItemSelected.selectedItem = [];
    }
    ['setTypeOrderTp'](data) {
        this.tpHeaderForm.typeOrder = data;
    }
    ['setTypeOfDocumentTp'](data) {
        this.typeOfDocument = data;
    }
    ['setListTpItem'](data) {
        this.tpItemForm = data;
    }
    ['setSelectedListItemByIndexTp']({ index, data }) {
        this.tpItemSelected.selectedItem[index] = data;
    }
    ['setEditItemSelectedTp']({ index, data }) {
        this.tpItemSelected.list[index] = data;
    }
    ['setNextPrevTpMigo'](data) {
        this.nextPrevItems.list = data;
    }
    ['afterCountDownTp'](data) {
        data.forEach((g) => {
            if (g.field.tabCode.toLowerCase() != 'header') {
                const split = g.field.name.split('-');
                const index = this.tpItemForm.list.findIndex((e) => {
                    return e.line == split[1];
                });
                this.errorListTpOther[index][split[2]] = true;
                this.tpItemForm.list[index].onEdit = true;
                this.tpItemForm.list[index].isActive = true;
                this.tpItemForm.list[index].isDisabledDelete = true;
            }
        });
    }
    ['setErrorListHeaderTp'](data) {
        this.errorListsTp.listHeader = data;
    }
    ['setImportFileTpOther']({ files, data, isError }) {
        if (isError)
            this.importFileTp.isError = isError;
        else {
            this.importFileTp.store.push(data);
            this.importFileTp.files = files;
            this.importFileTp.isError = isError;
        }
    }
    ['deleteImportFileTpOtherr'](fileName) {
        const index = this.importFileTp.store
            .map((x) => {
            return x.originalFileName;
        })
            .indexOf(fileName);
        this.importFileTp.store.splice(index, 1);
        this.importFileTp.files = null;
        this.importFileTp.isError = false;
    }
    ['setTpLookup']({ obj, data }) {
        this.tpLookup[obj] = data;
    }
    ['pushTempTpOther'](data) {
        this.tempTpOther.push(data);
    }
    ['resetTempTpOther']() {
        this.tempTpOther = [];
    }
    ['setDeleteSelectedItemTp'](data) {
        this.tpItemSelected.selectedItem.splice(data, 1);
    }
    ['setErrorRequiredAllTp'](data) {
        this.errorListsTp.requiredAll = data;
    }
    ['setErrorListItemTp'](data) {
        this.errorListsTp.listItem = data;
        this.tpItemSelected.list.forEach((g) => {
            g.errors = [...data];
        });
    }
    ['setIsSnNotBlankTp'](data) {
        const indexes = this.tpItemForm.list.findIndex((e) => {
            return e.line === data.line;
        });
        if (indexes !== -1)
            this.tpItemForm.list[indexes].isSnNotBlank = data.res;
    }
    ['setTempTpOther']({ value, tabParent, tabChild, line }) {
        const index = this.tempTpOther.findIndex((e) => {
            return e.line == line;
        });
        const obj = {
            val: value
        };
        this.tempTpOther[index][tabParent][tabChild] = obj.val;
    }
    ['setCurrentTpItemSelected'](data) {
        this.tpItemSelected.current = data;
    }
    ['setSelectedListItemTp'](data) {
        this.tpItemSelected.selectedItem = data;
    }
    ['deleteErrorListTpOther']() {
        this.errorListTpOther = [];
    }
    ['setErrorListTpOther'](obj) {
        this.errorListTpOther.push(obj);
    }
    ['updateErrorListTpOther'](obj) {
        this.errorListTpOther[obj.index][obj.property] = obj.value;
    }
    ['setSelectedTpItem'](data) {
        this.tpItemSelected.selectedItem = data;
    }
    ['addTpOther']() {
        const obj = {
            materialTab: {
                material: null,
                materialDesc: null,
                supplierMatNo: null,
                materialGroup: null,
                valType: null,
                valCat: null,
                mpnMaterial: null,
                equipment: null,
                materialNumber: null
            },
            quantityTab: {
                baseUom: null,
                qtySKU: null,
                baseSku: null,
                quantityOrdered: null,
                uoMOrdered: null,
                qty: null,
                goodsReceiptQuantity: null
            },
            whereTab: {
                movementType: this.tpHeaderForm.movementType,
                slocCode: null,
                specialStock: this.tpHeaderForm.specialStock,
                specialStockDescription: this.tpHeaderForm.specialStockDescription,
                type: null,
                plantCode: null,
                plantName: null,
                textItem: null,
                unloadingPoint: null,
                goodsRecipient: null,
                vendorName: null,
                vendorCode: null,
                storageBin: null
            },
            transferPostingTab: {
                from: {
                    material: null,
                    materialDesc: null,
                    plantCode: null,
                    plantName: null,
                    slocName: null,
                    slocCode: null,
                    vendorName: null,
                    vendorCode: null,
                    specialStock: this.tpHeaderForm.specialStock,
                    specialStockName: this.tpHeaderForm.specialStock,
                    specialStockDescription: this.tpHeaderForm.specialStockDescription,
                    valType: null,
                    qty: null,
                    baseUom: null,
                    storageBin: null
                },
                destination: {
                    material: null,
                    materialDesc: null,
                    plantCode: null,
                    plantName: null,
                    slocName: null,
                    slocCode: null,
                    vendorName: null,
                    vendorCode: null,
                    specialStock: this.tpHeaderForm.specialStock,
                    specialStockName: this.tpHeaderForm.specialStock,
                    specialStockDescription: this.tpHeaderForm.specialStockDescription,
                    valType: null,
                    storageBin: null
                }
            },
            serialNumberTab: {
                isSNIndicator: false,
                listSerialNumbers: null
            },
            enableFields: [
                'materialTab.materialDesc',
                'materialTab.valType',
                'quantityTab.qty',
                'whereTab.movementType',
                'whereTab.specialStock',
                'whereTab.slocCode',
                'whereTab.goodsRecipient',
                'whereTab.unloadingPoint',
                'whereTab.textItem',
                'whereTab.plantName',
                'whereTab.vendorCode',
                'transferPostingTab.from.plantCode'
            ],
            popoitemgrid: null,
            subConts: null,
            hideFields: [
                'materialTab.supplierMatNo',
                'materialTab.mpnMaterial',
                'materialTab.equipment',
                'quantityTab.quantityOrdered',
                'quantityTab.uoMOrdered',
                'quantityTab.goodsReceiptQuantity',
                'poDataTab.requsitioner',
                'poDataTab.purchaseOrder',
                'poDataTab.purchaseOrderItem',
                'poDataTab.delCompleteIndCode',
                'whereTab.reasonForMovement',
                'whereTab.reasonMovement'
            ],
            mandatoryFields: [
                'materialTab.materialDesc',
                'quantityTab.qty',
                'whereTab.movementType',
                'whereTab.plantName',
                'whereTab.slocCode'
            ],
            line: this.tpItemForm.list.length + 1,
            detailId: this.tpItemForm.list.length + 1,
            materialDocumentItem: null,
            categoryItem: null,
            isSnNotBlank: false,
            totalRecords: null,
            createdBy: null,
            createdDate: null,
            modifiedby: null,
            modifiedDate: null,
            errors: [],
            onEdit: true,
            isActive: true,
            isSaved: false,
            isSaveClicked: false,
            grType: 1,
            hasChildren: false,
            isDisabledDelete: false
        };
        this.tpItemForm.list.push(obj);
        this.tpItemSelected.current = obj;
        const check = this.tpItemSelected.list.findIndex((s) => {
            return s.detailId == obj.detailId;
        });
        if (check != -1)
            return;
        this.tpItemSelected.list.push(obj);
    }
    ['addTpOtherFromImport'](data) {
        const inputOtherType = data.type
            ? data.type === 'change' || data.type === 'cancel'
                ? true
                : false
            : false;
        const checkCancelType = data.type
            ? data.type === 'cancel'
                ? true
                : false
            : false;
        const checkMaterial = data.materialTab.material == '' || data.materialTab.material == null;
        const checkMaterialFrom = data.transferPostingTab.from.material == '' ||
            data.transferPostingTab.from.material == null;
        const checkMaterialDestination = data.transferPostingTab.destination.material == '' ||
            data.transferPostingTab.destination.material == null;
        const is541 = data.whereTab.movementType === '541';
        const obj = {
            materialTab: {
                material: data.materialTab.materialDesc,
                materialDesc: checkMaterial
                    ? null
                    : {
                        lookupVal: data.materialTab.material,
                        lookupText: data.materialTab.materialDesc,
                        lookupValText: data.materialTab.material +
                            ' | ' +
                            data.materialTab.materialDesc,
                        lookupData: null
                    },
                materialNumber: data.materialTab.material,
                supplierMatNo: data.materialTab.supplierMatNo,
                materialGroup: data.materialTab.materialGroup,
                valType: data.materialTab.valType,
                valCat: data.materialTab.valCat,
                mpnMaterial: data.materialTab.mpnMaterial,
                equipment: data.materialTab.equipment
            },
            quantityTab: {
                baseUom: data.quantityTab.baseUom,
                qtySKU: data.quantityTab.qtySKU,
                baseSku: data.quantityTab.baseSku,
                quantityOrdered: data.quantityTab.quantityOrdered,
                uoMOrdered: data.quantityTab.uoMOrdered,
                qty: data.quantityTab.qty,
                goodsReceiptQuantity: data.quantityTab.goodsReceiptQuantity
            },
            whereTab: {
                movementType: data.whereTab.movementType,
                slocCode: data.whereTab.slocCode === null || data.whereTab.slocCode === ''
                    ? null
                    : {
                        lookupVal: data.whereTab.slocCode,
                        lookupText: data.whereTab.slocName,
                        lookupValText: data.whereTab.slocCode + ' | ' + data.whereTab.slocName
                    },
                specialStock: data.whereTab.specialStock,
                type: data.whereTab.type,
                plantCode: data.whereTab.plantCode,
                plantName: data.whereTab.plantCode === null || data.whereTab.plantCode === ''
                    ? null
                    : {
                        lookupVal: data.whereTab.plantCode,
                        lookupText: data.whereTab.plantName,
                        lookupValText: data.whereTab.plantCode + ' | ' + data.whereTab.plantName,
                        lookupData: null
                    },
                textItem: data.whereTab.textItem,
                stockTypeCode: data.whereTab.stockTypeCode,
                storageBin: data.whereTab.storageBin,
                unloadingPoint: data.whereTab.unloadingPoint,
                goodsRecipient: data.whereTab.goodsRecipient,
                vendorCode: data.whereTab.vendorCode === null || data.whereTab.vendorCode === ''
                    ? null
                    : {
                        lookupVal: data.whereTab.vendorCode,
                        lookupText: data.whereTab.vendorName,
                        lookupValText: data.whereTab.vendorCode + ' | ' + data.whereTab.vendorName,
                        lookupData: null
                    },
                vendorName: inputOtherType
                    ? data.whereTab.vendorName
                    : data.whereTab.vendorName,
                reasonMovementCode: data.whereTab.reasonMovementCode,
                reasonForMovement: data.whereTab.reasonMovementCode
                    ? data.whereTab.reasonMovementCode
                    : null,
                reasonMovementDisplay: data.whereTab.reasonMovementDisplay,
                slocName: data.whereTab.slocName,
                stockTypeName: data.whereTab.stockTypeName
            },
            transferPostingTab: {
                destination: {
                    material: data.transferPostingTab.destination.materialDesc,
                    materialDesc: checkMaterialDestination
                        ? null
                        : {
                            lookupVal: data.transferPostingTab.destination.material,
                            lookupText: data.transferPostingTab.destination.materialDesc,
                            lookupValText: data.transferPostingTab.destination.material +
                                ' | ' +
                                data.transferPostingTab.destination.materialDesc,
                            lookupData: null
                        },
                    plantCode: is541
                        ? {
                            lookupVal: data.transferPostingTab.destination.plantCode,
                            lookupText: data.transferPostingTab.destination.plantName,
                            lookupValText: data.transferPostingTab.destination.plantCode +
                                ' | ' +
                                data.transferPostingTab.destination.plantName,
                            lookupData: null
                        }
                        : data.transferPostingTab.destination.plantCode,
                    plantName: data.transferPostingTab.destination.plantName,
                    slocName: data.transferPostingTab.destination.slocName,
                    slocCode: data.transferPostingTab.destination.slocCode === null ||
                        data.transferPostingTab.from.slocCode === ''
                        ? null
                        : {
                            lookupVal: data.transferPostingTab.destination.slocCode,
                            lookupText: data.transferPostingTab.destination.slocName,
                            lookupValText: data.transferPostingTab.destination.slocCode +
                                ' | ' +
                                data.transferPostingTab.destination.slocName
                        },
                    vendorName: data.transferPostingTab.destination.vendorName,
                    vendorCode: is541
                        ? {
                            lookupVal: data.transferPostingTab.destination.vendorCode,
                            lookupText: data.transferPostingTab.destination.vendorName,
                            lookupValText: data.transferPostingTab.destination.vendorCode +
                                ' | ' +
                                data.transferPostingTab.destination.vendorName,
                            lookupData: null
                        }
                        : data.transferPostingTab.destination.vendorCode,
                    specialStock: data.transferPostingTab.destination.specialStock,
                    specialStockName: data.transferPostingTab.destination.specialStockName,
                    specialStockDescription: data.transferPostingTab.destination.specialStockDescription,
                    valType: data.transferPostingTab.destination.valType,
                    storageBin: data.transferPostingTab.destination.storageBin
                },
                from: {
                    material: data.transferPostingTab.from.materialDesc,
                    materialDesc: checkMaterialFrom
                        ? null
                        : {
                            lookupVal: data.transferPostingTab.from.material,
                            lookupText: data.transferPostingTab.from.materialDesc,
                            lookupValText: data.transferPostingTab.from.material +
                                ' | ' +
                                data.transferPostingTab.from.materialDesc,
                            lookupData: null
                        },
                    plantCode: data.transferPostingTab.from.plantCode,
                    plantName: {
                        lookupVal: data.transferPostingTab.from.plantCode,
                        lookupText: data.transferPostingTab.from.plantName,
                        lookupValText: data.transferPostingTab.from.plantCode +
                            ' | ' +
                            data.transferPostingTab.from.plantName,
                        lookupData: null
                    },
                    slocName: data.transferPostingTab.from.slocName,
                    slocCode: data.transferPostingTab.from.slocCode === null ||
                        data.transferPostingTab.from.slocCode === ''
                        ? null
                        : {
                            lookupVal: data.transferPostingTab.from.slocCode,
                            lookupText: data.transferPostingTab.from.slocName,
                            lookupValText: data.transferPostingTab.from.slocCode +
                                ' | ' +
                                data.transferPostingTab.from.slocName
                        },
                    vendorName: data.transferPostingTab.from.vendorName,
                    vendorCode: {
                        lookupVal: data.transferPostingTab.from.vendorCode,
                        lookupText: data.transferPostingTab.from.vendorName,
                        lookupValText: data.transferPostingTab.from.vendorCode +
                            ' | ' +
                            data.transferPostingTab.from.vendorName,
                        lookupData: null
                    },
                    specialStock: data.transferPostingTab.from.specialStock,
                    specialStockName: data.transferPostingTab.from.specialStockName,
                    specialStockDescription: data.transferPostingTab.from.specialStockDescription,
                    valType: data.transferPostingTab.from.valType,
                    storageBin: data.transferPostingTab.from.storageBin,
                    qty: data.transferPostingTab.from.qty,
                    baseUom: data.transferPostingTab.from.baseUom
                }
            },
            serialNumberTab: {
                isSNIndicator: data.serialNumberTab.isSNIndicator,
                listSerialNumbers: data.serialNumberTab.listSerialNumbers
            },
            enableFields: data.enableFields,
            mandatoryFields: inputOtherType
                ? data.mandatoryFields
                : [
                    'materialTab.materialDesc',
                    'quantityTab.qty',
                    'whereTab.movementType',
                    'whereTab.slocCode',
                    'whereTab.reasonMovement',
                    'whereTab.plantName'
                ],
            popoitemgrid: inputOtherType ? data.popoitemgrid : null,
            subConts: inputOtherType ? data.subConts : null,
            hideFields: data.hideFields,
            line: data.line,
            detailId: inputOtherType ? data.detailId : data.line,
            materialDocumentItem: data.materialDocumentItem,
            categoryItem: inputOtherType ? data.categoryItem : null,
            isSnNotBlank: data.isSnNotBlank,
            totalRecords: inputOtherType ? data.totalRecords : null,
            createdBy: inputOtherType ? data.createdBy : null,
            createdDate: inputOtherType ? data.createdDate : null,
            modifiedby: null,
            modifiedDate: null,
            errors: [],
            onEdit: false,
            isActive: checkCancelType ? false : true,
            isSaved: true,
            isSaveClicked: false,
            isDisabledDelete: false,
            isCanceled: data.isCanceled,
            isCancelDoc: data.isCancelDoc,
            disableCheckbox: data.isCanceled,
            hasChildren: data.hasChildren
        };
        const errorListObj = {
            materialDesc: false,
            qty: false,
            slocCode: false,
            vendorCode: false,
            movementType: false,
            specialStock: false,
            slocCodeTp: false
        };
        this.errorListTpOther.push(errorListObj);
        this.tpItemForm.list.push(obj);
        this.tpItemSelected.current = obj;
        const check = this.tpItemSelected.list.findIndex((s) => {
            return s.detailId == obj.detailId;
        });
        if (check != -1 || checkCancelType)
            return;
        this.tpItemSelected.list.push(obj);
        this.tpItemSelected.selectedItem.push(obj);
    }
    ['callTypeOtherTp']({ mvtype, specialstock, theIndex }) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/master/mvtype/desc?MovementType=` +
                mvtype +
                '&SpecialStock=' +
                specialstock +
                '&ver=v1';
            return yield new Promise((resolve, reject) => {
                ApiService.get(apiUrl)
                    .then((response) => {
                    const axiosResponse = response.data.result;
                    if (axiosResponse.isError) {
                        this.context.commit('setErrorHandlerMigo', axiosResponse);
                        resolve();
                    }
                    else {
                        const content = axiosResponse.content;
                        this.tpItemForm.list[theIndex].whereTab.type = content.mvtTypeDesc;
                        resolve();
                    }
                })
                    .catch((error) => {
                    if (error.response) {
                        const data = {
                            statusCode: error.response.status,
                            message: error.response.statusText
                        };
                        this.context.commit('setErrorHandlerMigo', data);
                    }
                    reject(error);
                });
            });
        });
    }
    ['callGetSnNotBlankTp'](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const material = isObject(data.materialNumber)
                ? data.materialNumber.lookupVal
                : data.materialNumber;
            const plant = isObject(data.plantName)
                ? data.plantName.lookupVal
                : data.plantName;
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/general/isnotblank?ver=v1&materialNumber=${material}&plant=${plant}`;
            return yield new Promise((resolve, reject) => {
                ApiService.get(apiUrl)
                    .then((res) => {
                    const obj = {
                        res: res.data.result.content.isNotBlank,
                        line: data.line
                    };
                    this.context.commit('setIsSnNotBlankTp', obj);
                    resolve();
                })
                    .catch((error) => {
                    if (error.response) {
                        const data = {
                            statusCode: error.response.status,
                            message: error.response.statusText
                        };
                        this.context.commit('setErrorHandlerMigo', data);
                    }
                    reject(error);
                });
            });
        });
    }
    ['callStorageBinTp']({ material, plant, sloc, index, type }) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/general/storagebin?ver=v1&materialNumber=` +
                material +
                '&plant=' +
                plant +
                '&sloc=' +
                sloc;
            return yield new Promise((resolve, reject) => {
                ApiService.get(apiUrl)
                    .then((response) => {
                    const axiosResponse = response.data.result;
                    if (axiosResponse.isError) {
                        this.context.commit('setErrorHandlerMigo', axiosResponse);
                        resolve();
                    }
                    else {
                        const content = axiosResponse.content;
                        if (type && type === 'from') {
                            this.tpItemSelected.current.whereTab.storageBin =
                                content.storageBin;
                            this.tpItemSelected.current.transferPostingTab.from.storageBin =
                                content.storageBin;
                        }
                        else if (type && type === 'destination') {
                            this.tpItemSelected.current.transferPostingTab.destination.storageBin =
                                content.storageBin;
                        }
                        resolve();
                    }
                })
                    .catch((error) => {
                    if (error.response) {
                        const data = {
                            statusCode: error.response.status,
                            message: error.response.statusText
                        };
                        this.context.commit('setErrorHandlerMigo', data);
                    }
                    reject(error);
                });
            });
        });
    }
    ['callSpStockDestination']({ mvtype, spStock }) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/transferposting/special_stock_destination?ver=v1&movementType=` +
                mvtype +
                '&specialStockCode=' +
                spStock;
            return yield new Promise((resolve, reject) => {
                ApiService.get(apiUrl)
                    .then((response) => {
                    const axiosResponse = response.data.result;
                    if (axiosResponse.isError) {
                        this.context.commit('setErrorHandlerMigo', axiosResponse);
                        resolve();
                    }
                    else {
                        this.tpItemSelected.current.transferPostingTab.destination.specialStock =
                            axiosResponse.content.specialStockCode;
                        this.tpItemSelected.current.transferPostingTab.destination.specialStockName =
                            axiosResponse.content.specialStockName;
                        this.tpItemSelected.current.transferPostingTab.destination.specialStockDescription =
                            axiosResponse.content.specialStockDescription;
                        resolve();
                    }
                })
                    .catch((error) => {
                    if (error.response) {
                        const data = {
                            statusCode: error.response.status,
                            message: error.response.statusText
                        };
                        this.context.commit('setErrorHandlerMigo', data);
                    }
                    reject(error);
                });
            });
        });
    }
    ['resetTp']() {
        this.tempId = null;
        this.isTpSearched = false;
        this.tabConditionTp = 'header';
        this.tpHeaderForm = {
            typeReceipt: '',
            postType: '',
            movType: '',
            materialDocumentYear: moment(new Date()).format('DD MMM YYYY'),
            matDocYear: null,
            indexReceipt: 0,
            indexPostType: 0,
            indexMvType: 0,
            typeOrder: null,
            orderNumber: null,
            reservationNumber: null,
            noPurchaseOrder: null,
            poItem: null,
            itemNo: '',
            documentDate: moment(new Date()).format('DD MMM YYYY'),
            deliveryNote: null,
            supplier: null,
            postingDate: moment(new Date()).format('DD MMM YYYY'),
            billOfLading: null,
            headerText: null,
            giUploadAttachment: [],
            vendorName: null,
            vendorNumber: null,
            submitClick: false,
            uploadTp: [],
            movementType: null,
            specialStock: null,
            documentStatus: '',
            documentStatusCode: '',
            documentType: '',
            documentTypeCode: '',
            bSpaceMatDoc: '',
            materialDocument: '',
            hasMatDoc: null,
            materialSlip: '',
            isCancelDoc: false,
            specialStockDescription: null,
            materialDocumentRead: null
        };
        this.nextPrevItems = {
            list: []
        };
        this.tpItemForm = {
            documentType: '',
            viewType: '',
            current: {},
            list: [],
            totalRecords: 0,
            totalPages: 0
        };
        this.tpItemSelected = {
            current: {},
            list: [],
            selectedItem: [],
            isAllSelected: false
        };
        this.tempTpOther = [];
        this.errorListTpOther = [
            {
                materialDesc: false,
                qty: false,
                slocCode: false,
                vendorCode: false,
                movementType: false,
                specialStock: false,
                slocCodeTp: false
            }
        ];
        this.errorListsTp = {
            postClicked: false,
            requiredAll: false,
            snNotSame: false,
            listItem: [],
            listHeader: []
        };
        this.headerErrorTp = {
            documentDate: false,
            materialSlip: false,
            postingDate: false,
            docHeaderText: false
        };
        this.importFileTp.files = null;
        this.importFileTp.store = [];
        this.importFileTp.isError = false;
        this.importFileTp.isImported = false;
        this.importFileTp.isAllowImport = true;
    }
    ['setTpUpload'](data) {
        this.tpHeaderForm.uploadTp.push(data);
    }
    ['uploadFilesTpHeader']({ file, apiUrl }) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${process.env.VUE_APP_BASE_URL_DIGITAL}` + apiUrl;
            // eslint-disable-next-line prefer-const, no-var
            let dataForm = new FormData();
            dataForm.append('request', file);
            return yield new Promise((resolve, reject) => {
                ApiService.postImages(url, dataForm)
                    .then((response) => {
                    const check = response.data.result;
                    if (check.isError) {
                        this.context.commit('setErrorHandlerMigo', check);
                        resolve();
                    }
                    else {
                        const data = check.content;
                        const fileName = `${data[0].originalFileName}.${data[0].fileType}`;
                        const getFile = this.tpHeaderForm.uploadTp.findIndex((s) => {
                            return s.originalFileName == fileName;
                        });
                        if (getFile >= 0) {
                            this.tpHeaderForm.uploadTp[getFile] = Object.assign(Object.assign({}, data[0]), { isSuccessDownload: false, isFailedDownload: false, isDownloading: false });
                        }
                        resolve();
                    }
                })
                    .catch((error) => {
                    if (error.response) {
                        const obj = {
                            statusCode: error.response.status
                        };
                        this.context.commit('setErrorHandlerMigo', obj);
                        reject(error);
                    }
                    else {
                        reject(error);
                    }
                });
            });
        });
    }
    ['deleteFileTpHeader'](fileUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/upload?ver=v1&fileUrl=` +
                fileUrl;
            return yield new Promise((resolve, reject) => {
                ApiService.delete(apiUrl)
                    .then(() => {
                    const index = this.tpHeaderForm.uploadTp
                        .map((x) => {
                        return x.formattedFileName;
                    })
                        .indexOf(fileUrl);
                    this.tpHeaderForm.uploadTp.splice(index, 1);
                    resolve();
                })
                    .catch((error) => {
                    if (error.response) {
                        const obj = {
                            statusCode: error.response.status
                        };
                        this.context.commit('setErrorHandlerMigo', obj);
                        reject(error);
                    }
                    else {
                        reject(error);
                    }
                });
            });
        });
    }
    ['setDetailTpHeader'](data) {
        const header = data.header;
        this.tpHeaderForm.noPurchaseOrder = header.poNumber;
        (this.tpHeaderForm.typeOrder = header.typeOrder),
            (this.tpHeaderForm.documentDate = moment(header.documentDate).format('DD MMM YYYY'));
        this.tpHeaderForm.postingDate = moment(header.postingDate).format('DD MMM YYYY');
        this.tpHeaderForm.headerText = header.docHeaderText;
        this.tpHeaderForm.movementType = header.movementType;
        this.tpHeaderForm.specialStock = header.specialStock;
        this.tpHeaderForm.documentStatus = header.documentStatus;
        this.tpHeaderForm.documentStatusCode = header.documentStatusCode;
        this.tpHeaderForm.documentType = header.documentType;
        this.tpHeaderForm.documentTypeCode = header.documentTypeCode;
        this.tpHeaderForm.postType = header.postingType;
        this.tpHeaderForm.typeReceipt = header.transactionType
            ? header.transactionType.replace(/\s/g, '')
            : null;
        this.tpHeaderForm.bSpaceMatDoc = header.bSpaceMatDoc;
        this.tpHeaderForm.materialSlip = header.materialSlip;
        this.tpHeaderForm.uploadTp = data.attachments;
        (this.tpHeaderForm.hasMatDoc = header.hasMatDoc),
            (this.tpHeaderForm.isCancelDoc = header.isCancelDoc);
        this.tpHeaderForm.orderNumber = header.orderNumber;
        this.tpHeaderForm.reservationNumber = header.reservation;
        this.tpHeaderForm.matDocYear = header.refMaterialDocumentYear;
        this.tpHeaderForm.materialDocument = header.refMaterialDocument;
        this.tpHeaderForm.materialDocumentRead = header.materialDocument;
    }
    get getIsTpSearched() {
        return this.isTpSearched;
    }
    ['setIsTpSearched'](data) {
        this.isTpSearched = data;
    }
    ['migoImportTemplateTp']() {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/transferposting/other/downloadtemplate?ver=v1`;
            return yield new Promise((resolve, reject) => {
                ApiService.getBlob(apiUrl)
                    .then((response) => {
                    const fileName = response.headers['content-disposition']
                        .split('; ')[1]
                        .split('=')[1];
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    this.context.commit('setPreventDiscardMigo', false);
                    resolve();
                })
                    .catch((error) => {
                    if (error.response) {
                        const data = {
                            statusCode: error.response.status,
                            message: error.response.statusText
                        };
                        this.context.commit('setErrorHandlerMigo', data);
                    }
                    reject(error);
                });
            });
        });
    }
    ['MigoImportFileTp']() {
        return __awaiter(this, void 0, void 0, function* () {
            this.importFileTp.isOnAsync = true;
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/transferposting/other/importexcel?ver=v1`;
            const dataForm = new FormData();
            dataForm.append('request', this.importFileTp.files);
            return yield new Promise((resolve, reject) => {
                ApiService.postImages(apiUrl, dataForm)
                    .then((response) => {
                    this.importFileTp.isOnAsync = false;
                    this.context.commit('setIsOnImportTp', true);
                    const res = response.data.result;
                    if (res.isError) {
                        if (res.content === null) {
                            const errorData = {
                                statusCode: undefined,
                                message: res.message
                            };
                            this.importFileTp.isError = true;
                            this.context.commit('setErrorHandlerMigo', errorData);
                        }
                        if (res.content.data.length == 0) {
                            const errorData = {
                                statusCode: undefined,
                                message: res.content.errorSets[0].errors[0]
                            };
                            this.importFileTp.isError = true;
                            this.context.commit('setErrorHandlerMigo', errorData);
                            resolve();
                        }
                        else if (res.content.data.length > 0) {
                            this.importFileTp.isError = true;
                            this.importFileTp.isImported = true;
                            this.importFileTp.isAllowImport = false;
                            this.tpItemForm.list = [];
                            this.tpItemSelected.list = [];
                            this.context.commit('deleteErrorListTpOther');
                            const data = res.content.data;
                            let countDown = 0;
                            data.forEach((e) => {
                                countDown++;
                                store.commit('addTpOtherFromImport', e);
                                if (countDown === data.length) {
                                    store.commit('afterCountDownTp', res.content.errorSets);
                                }
                            });
                            const errorItem = [];
                            const errorHeader = [];
                            res.content.errorSets.forEach((g) => {
                                if (g.field.tabCode.toLowerCase() != 'header') {
                                    errorItem.push(g);
                                }
                                else {
                                    errorHeader.push(g);
                                }
                            });
                            this.context.commit('setErrorListItemTp', errorItem);
                            this.context.commit('setErrorListHeaderTp', errorHeader);
                            this.tpItemSelected.list.forEach((g) => {
                                g.errors = [...errorItem];
                            });
                            resolve();
                        }
                    }
                    else {
                        this.tpItemForm.list = [];
                        this.tpItemSelected.list = [];
                        this.context.commit('deleteErrorListTpOther');
                        this.importFileTp.isImported = true;
                        this.importFileTp.isAllowImport = false;
                        const data = res.content.data;
                        data.forEach((e) => {
                            store.commit('addTpOtherFromImport', e);
                        });
                        // Ganti modal gi
                        hideModal(document.getElementById('modal_import_gr_item'));
                        resolve();
                    }
                })
                    .catch((error) => {
                    if (error.response) {
                        const data = {
                            statusCode: error.response.status,
                            message: error.response.statusText
                        };
                        this.context.commit('setErrorHandlerMigo', data);
                    }
                    reject(error);
                });
            });
        });
    }
    ['callDetailHeaderTp'](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const headerId = data.headerId;
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/transferposting/detail/${headerId}?ver=v1&viewType=` +
                data.type;
            return yield new Promise((resolve, reject) => {
                ApiService.get(apiUrl)
                    .then((response) => {
                    const res = response.data.result;
                    if (res.isError) {
                        this.context.commit('setErrorHandlerMigo', res);
                        resolve();
                    }
                    else {
                        this.context.commit('setDetailTpHeader', Object.assign(Object.assign({}, res.content), { type: data.type }));
                        this.context.commit('setViewHeaderTp', res.content);
                        const headerData = res.content.header;
                        const errorItem = [];
                        if (!headerData.isSAPSuccess) {
                            const getList = headerData.sapMessage.split(',');
                            getList.forEach((item) => {
                                const getLineName = item.split(':');
                                if (getLineName.length === 1) {
                                    errorItem.push({
                                        field: {
                                            name: '',
                                            tabCode: ''
                                        },
                                        errors: []
                                    });
                                    errorItem[0].errors.push(getLineName[0]);
                                    return;
                                }
                                const getNumberLine = getLineName[0].split(' ');
                                const checkError = errorItem.findIndex((itemSub) => {
                                    const getLine = itemSub.field.name.split('-');
                                    return getLine[1] === getNumberLine[1];
                                });
                                if (checkError !== -1) {
                                    errorItem[checkError].errors.push(getLineName[1]);
                                }
                                else {
                                    const messageData = () => {
                                        let message = '';
                                        getLineName.forEach((e, index) => {
                                            if (index !== 0)
                                                message += e + ' ';
                                        });
                                        return message;
                                    };
                                    errorItem.push({
                                        field: {
                                            name: `Item-${getNumberLine[1]}`,
                                            tabCode: ''
                                        },
                                        errors: [
                                            getList.length === 1
                                                ? headerData.sapMessage
                                                : messageData()
                                        ]
                                    });
                                }
                            });
                            this.context.commit('setErrorListItemTp', errorItem);
                        }
                        resolve(res.content);
                    }
                })
                    .catch((error) => {
                    if (error.response) {
                        const obj = {
                            statusCode: error.response.status
                        };
                        this.context.commit('setErrorHandlerMigo', obj);
                        reject(error);
                    }
                    else {
                        const obj = {
                            message: error
                        };
                        this.context.commit('setErrorHandlerMigo', obj);
                        reject(error);
                    }
                });
            });
        });
    }
    ['callDetailItemTp'](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const headerId = data.headerId;
            const type = data.params.viewType;
            const payloadData = data.params;
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/transferposting/detail/${headerId}/item?ver=v1`;
            return yield new Promise((resolve, reject) => {
                ApiService.post(apiUrl, payloadData)
                    .then((response) => {
                    this.context.commit('setClearSelectedItemTp');
                    const res = response.data.result;
                    if (res.isError) {
                        this.context.commit('setErrorHandlerMigo', res);
                        resolve();
                    }
                    else {
                        if (type === 'change' || type === 'cancel') {
                            this.tpItemForm.list = [];
                            this.tpItemSelected.list = [];
                            this.context.commit('deleteErrorListTpOther');
                            const fixType = this.tpHeaderForm.documentTypeCode === 'TP_OTHER'
                                ? 'Other'
                                : null;
                            if (fixType === 'Other') {
                                const data = res.content.data;
                                store.commit('resetTempTpOther');
                                data.forEach((e) => {
                                    store.commit('addTpOtherFromImport', Object.assign(Object.assign({}, e), { type }));
                                    const obj = {
                                        line: e.line,
                                        materialTab: {
                                            material: null,
                                            materialDesc: null,
                                            valType: null
                                        },
                                        quantityTab: {
                                            baseUom: null,
                                            qty: null
                                        },
                                        whereTab: {
                                            movementType: null,
                                            slocCode: null,
                                            specialStock: null,
                                            plantCode: null,
                                            plantName: null,
                                            textItem: null,
                                            stockTypeCode: null,
                                            storageBin: null,
                                            unloadingPoint: null,
                                            goodsRecipient: null,
                                            reasonMovementCode: null,
                                        },
                                        transferPostingTab: {
                                            from: {
                                                slocName: null,
                                                slocCode: null
                                            },
                                            destination: {
                                                slocName: null,
                                                slocCode: null
                                            }
                                        }
                                    };
                                    store.commit('pushTempTpOther', obj);
                                });
                            }
                            else {
                                if (type == 'cancel') {
                                    store.commit('resetTempGiOther');
                                    res.content.data.forEach((e) => {
                                        this.tpItemForm.list.push(Object.assign({ disableCheckbox: e.isCanceled }, e));
                                    });
                                }
                                else {
                                    this.tpItemForm.list = res.content.data;
                                }
                                this.tpItemSelected.list = this.tpItemForm.list;
                                this.tpItemSelected.selectedItem =
                                    type === 'change' ? this.tpItemForm.list : [];
                            }
                            this.tpItemForm.totalPages = res.content.totalPages;
                            this.tpItemForm.totalRecords = res.content.totalRecords;
                            this.context.commit('setListTpItem', Object.assign(Object.assign({}, this.tpItemForm), { totalPages: res.content.totalPages, totalRecords: res.content.totalRecords }));
                            if (this.tpHeaderForm.typeReceipt === 'PlaceInStorage') {
                                this.tpItemForm.list.forEach((_e) => {
                                    const errorListObjNew = {
                                        materialDesc: false,
                                        qty: false,
                                        slocCode: false,
                                        vendorCode: false,
                                        movementType: false,
                                        specialStock: false,
                                        slocCodeTp: false,
                                        reasonMovementCode: false
                                    };
                                    this.context.commit('setErrorListTpOther', errorListObjNew);
                                });
                            }
                            this.context.commit('setCurrentTpItemSelected', this.tpItemForm.list[0]);
                            if (type == 'change') {
                                this.tpItemForm.list.forEach((e) => {
                                    e.isActive = true;
                                });
                            }
                        }
                        else {
                            this.context.commit('setTypeOfDocument', this.tpHeaderForm.postType);
                            this.context.commit('setTpItemList', res.content);
                            this.context.commit('setCurrentTpItemSelected', res.content.data[0]);
                        }
                        resolve();
                    }
                })
                    .catch((error) => {
                    if (error.response) {
                        const obj = {
                            statusCode: error.response.status
                        };
                        this.context.commit('setErrorHandlerMigo', obj);
                        reject(error);
                    }
                    else {
                        const obj = {
                            message: error
                        };
                        this.context.commit('setErrorHandlerMigo', obj);
                        reject(error);
                    }
                });
            });
        });
    }
    get getViewHeaderTp() {
        return this.viewHeader;
    }
    ['setViewHeaderTp'](data) {
        this.viewHeader = data;
    }
    ['setResetViewHeaderTp']() {
        this.viewHeader = {};
    }
    get getHeaderIdTp() {
        return this.headerId;
    }
    ['setHeaderIdTp'](data) {
        this.headerId = data;
    }
    get getTempIdTp() {
        return this.tempId;
    }
    ['setTempId'](data) {
        this.tempId = data;
    }
    get getTpSelectedItem() {
        return this.tpItemSelected;
    }
    get getHeaderErrorTp() {
        return this.headerErrorTp;
    }
    get getTpItemList() {
        return this.tpItemForm;
    }
    ['setTpItemList'](dataObj) {
        this.tpItemForm.documentType = dataObj.data[0].typeOrder;
        this.tpItemForm.viewType = dataObj.data[0].mode;
        this.tpItemForm.list = dataObj.data;
        this.tpItemForm.totalPages = dataObj.totalPages;
        this.tpItemForm.totalRecords = dataObj.totalRecords;
    }
    ['submitPostTp']({ conditions, data, type }) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/transferposting/` +
                type +
                '/' +
                conditions +
                '?ver=v1';
            return yield new Promise((resolve, reject) => {
                ApiService.post(apiUrl, data)
                    .then((response) => {
                    const res = response.data.result;
                    this.importFileTp.isError = false;
                    if (res.isError && res.content === null) {
                        this.context.commit('setErrorHandlerMigo', res);
                        resolve();
                    }
                    else if (res.isError && res.content != null) {
                        this.context.commit('setHeaderIdTp', res.content.headerId);
                        const errorItem = [];
                        const errorHeader = [];
                        if (res.content.isErrorSap) {
                            const fixValue = 'Order';
                            const obj = {
                                text: 'The display will switch to the "change" mode and please correct the data errors',
                                flag: conditions,
                                isErrorSap: true,
                                typeOrder: fixValue,
                                headerId: res.content.headerId
                            };
                            this.context.commit('setPreventDiscardMigo', true);
                            this.context.commit('setInformationMigo', obj);
                            resolve();
                        }
                        else {
                            res.content.errorSets.forEach((g) => {
                                if (g.field.tabCode.toLowerCase() != 'header') {
                                    errorItem.push(g);
                                }
                                else {
                                    errorHeader.push(g);
                                }
                            });
                            this.context.commit('setErrorListItemTp', errorItem);
                            this.context.commit('setErrorListHeaderTp', errorHeader);
                            this.tpItemSelected.list.forEach((g) => {
                                g.errors = [...errorItem];
                            });
                            resolve();
                        }
                    }
                    else {
                        const obj = {
                            text: res.message,
                            flag: conditions,
                            isErrorSap: false,
                            typeOrder: null,
                            headerId: null
                        };
                        if (res.content.isInProgressSAP)
                            this.context.commit('setInformationMigo', obj);
                        else
                            this.context.commit('setSuccessMigo', obj);
                        resolve();
                    }
                })
                    .catch((error) => {
                    store.commit(MutationsGeneral.SET_ALLOW_SUBMIT, true);
                    if (error.response) {
                        const obj = {
                            statusCode: error.response.status
                        };
                        this.context.commit('setErrorHandlerMigo', obj);
                        reject(error);
                    }
                    else {
                        const obj = {
                            message: error
                        };
                        this.context.commit('setErrorHandlerMigo', obj);
                        reject(error);
                    }
                });
            });
        });
    }
    ['deleteTpTransactionList'](data) {
        return __awaiter(this, void 0, void 0, function* () {
            const headerId = data.headerId;
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/transferposting/delete/${headerId}?ver=v1`;
            const params = {};
            return yield new Promise((resolve, reject) => {
                ApiService.post(apiUrl, params)
                    .then((response) => {
                    const res = response.data.result;
                    if (res.isError) {
                        this.context.commit('setErrorHandlerMigo', res);
                        resolve();
                    }
                    else {
                        const obj = {
                            id: data.id === 'modal_confirmation_tp' ? 'modal_success_tp' : null,
                            text: res.message
                        };
                        this.context.commit('setSuccessMigo', obj);
                        resolve();
                    }
                })
                    .catch((error) => {
                    if (error.response) {
                        const obj = {
                            statusCode: error.response.status
                        };
                        this.context.commit('setErrorHandlerMigo', obj);
                        reject(error);
                    }
                    else {
                        reject(error);
                    }
                });
            });
        });
    }
    ['searchHeaderTpPis']({ materialDocument, materialDocumentYear, conditions, pageNumber, pageSize }) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = conditions === 'header'
                ? `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/transferposting/placeinstorage/materialdocument/search?ver=v1`
                : `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/transferposting/detail/${this.tempId}/stageitem?ver=v1`;
            const params = {
                materialDocument,
                materialDocumentYear,
                conditions,
                pageNumber,
                pageSize
            };
            return yield new Promise((resolve, reject) => {
                ApiService.post(apiUrl, params)
                    .then((response) => {
                    const res = response.data.result;
                    const data = response.data.result;
                    const content = data.content;
                    if (res.isError) {
                        this.context.commit('setErrorHandlerMigo', res);
                        resolve();
                    }
                    else {
                        if (conditions === 'header') {
                            this.context.commit('setTempId', res.content.tempId);
                            this.tpHeaderForm.matDocYear = materialDocumentYear;
                            this.tpHeaderForm.materialSlip = res.content.materialSlip;
                            this.tpHeaderForm.headerText = res.content.docHeaderText;
                            this.context.commit('setIsTpSearched', true);
                        }
                        else if (conditions === 'item') {
                            // this.context.commit('addTpOtherFromImport', content.data)
                            const dataList = {
                                data: [],
                                totalPages: content.totalPages,
                                totalRecords: content.totalRecords
                            };
                            content.data.forEach((g) => {
                                dataList.data.push(Object.assign({ checked: false, onEdit: false, isActive: false, isSaved: true }, g));
                                const errorListObj = {
                                    materialDesc: false,
                                    qty: false,
                                    slocCode: false,
                                    vendorCode: false,
                                    movementType: false,
                                    specialStock: false,
                                    slocCodeTp: false
                                };
                                this.errorListTpOther.push(errorListObj);
                            });
                            this.context.commit('setTpItemList', dataList);
                            this.context.commit('setCurrentTpItemSelected', content.data[0]);
                        }
                        resolve();
                    }
                })
                    .catch((error) => {
                    if (error.response) {
                        const obj = {
                            statusCode: error.response.status
                        };
                        this.context.commit('setErrorHandlerMigo', obj);
                        reject(error);
                    }
                    else {
                        reject(error);
                    }
                });
            });
        });
    }
    ['cancelPostTp']({ conditions, data, type }) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-migo/api/transferposting/cancel?ver=v1`;
            return yield new Promise((resolve, reject) => {
                ApiService.post(apiUrl, data)
                    .then((response) => {
                    const res = response.data.result;
                    this.importFileTp.isError = false;
                    // this.headerId = 0
                    if (res.isError && res.content === null) {
                        this.context.commit('setErrorHandlerMigo', res);
                        resolve();
                    }
                    else if (res.isError && res.content != null) {
                        this.context.commit('setHeaderIdTp', res.content.headerId);
                        const errorItem = [];
                        const errorHeader = [];
                        if (res.content.isErrorSap) {
                            const fixValue = 'Other';
                            const obj = {
                                text: 'The display will switch to the "change" mode and please correct the data errors',
                                flag: conditions,
                                isErrorSap: true,
                                typeOrder: fixValue,
                                headerId: res.content.headerId
                            };
                            this.context.commit('setPreventDiscardMigo', true);
                            this.context.commit('setInformationMigo', obj);
                            resolve();
                        }
                        else {
                            res.content.errorSets.forEach((g) => {
                                if (g.field.tabCode.toLowerCase() != 'header') {
                                    errorItem.push(g);
                                }
                                else {
                                    errorHeader.push(g);
                                }
                            });
                            this.context.commit('setErrorListItemTp', errorItem);
                            this.context.commit('setErrorListHeaderTp', errorHeader);
                            this.tpItemSelected.list.forEach((g) => {
                                g.errors = [...errorItem];
                            });
                            resolve();
                        }
                    }
                    else {
                        const obj = {
                            text: res.message,
                            flag: conditions,
                            isErrorSap: false,
                            typeOrder: null,
                            headerId: null
                        };
                        if (res.content.isInProgressSAP)
                            this.context.commit('setInformationMigo', obj);
                        else
                            this.context.commit('setSuccessMigo', obj);
                        resolve();
                    }
                })
                    .catch((error) => {
                    store.commit(MutationsGeneral.SET_ALLOW_SUBMIT, true);
                    if (error.response) {
                        const obj = {
                            statusCode: error.response.status
                        };
                        this.context.commit('setErrorHandlerMigo', obj);
                        reject(error);
                    }
                    else {
                        reject(error);
                    }
                });
            });
        });
    }
    get getTabConditionTp() {
        return this.tabConditionTp;
    }
    ['setTabConditionTp'](data) {
        this.tabConditionTp = data;
    }
    ['setPostClickedTp'](data) {
        this.errorListsTp.postClicked = data;
    }
    ['setErrorSnNotSameTp'](data) {
        this.errorListsTp.snNotSame = data;
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionTpModule.prototype, 'setPlantListTp', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionTpModule.prototype, 'setIsOnImportTp', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], transactionTpModule.prototype, 'setClearSelectedItemTp', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionTpModule.prototype, 'setTypeOrderTp', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionTpModule.prototype, 'setTypeOfDocumentTp', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionTpModule.prototype, 'setListTpItem', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionTpModule.prototype, 'setSelectedListItemByIndexTp', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionTpModule.prototype, 'setEditItemSelectedTp', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionTpModule.prototype, 'setNextPrevTpMigo', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionTpModule.prototype, 'afterCountDownTp', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionTpModule.prototype, 'setErrorListHeaderTp', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionTpModule.prototype, 'setImportFileTpOther', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionTpModule.prototype, 'deleteImportFileTpOtherr', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionTpModule.prototype, 'setTpLookup', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionTpModule.prototype, 'pushTempTpOther', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], transactionTpModule.prototype, 'resetTempTpOther', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionTpModule.prototype, 'setDeleteSelectedItemTp', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionTpModule.prototype, 'setErrorRequiredAllTp', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionTpModule.prototype, 'setErrorListItemTp', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionTpModule.prototype, 'setIsSnNotBlankTp', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionTpModule.prototype, 'setTempTpOther', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionTpModule.prototype, 'setCurrentTpItemSelected', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionTpModule.prototype, 'setSelectedListItemTp', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], transactionTpModule.prototype, 'deleteErrorListTpOther', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionTpModule.prototype, 'setErrorListTpOther', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionTpModule.prototype, 'updateErrorListTpOther', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionTpModule.prototype, 'setSelectedTpItem', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], transactionTpModule.prototype, 'addTpOther', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionTpModule.prototype, 'addTpOtherFromImport', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], transactionTpModule.prototype, 'callTypeOtherTp', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], transactionTpModule.prototype, 'callGetSnNotBlankTp', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], transactionTpModule.prototype, 'callStorageBinTp', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], transactionTpModule.prototype, 'callSpStockDestination', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], transactionTpModule.prototype, 'resetTp', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionTpModule.prototype, 'setTpUpload', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], transactionTpModule.prototype, 'uploadFilesTpHeader', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], transactionTpModule.prototype, 'deleteFileTpHeader', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionTpModule.prototype, 'setDetailTpHeader', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionTpModule.prototype, 'setIsTpSearched', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], transactionTpModule.prototype, 'migoImportTemplateTp', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], transactionTpModule.prototype, 'MigoImportFileTp', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], transactionTpModule.prototype, 'callDetailHeaderTp', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], transactionTpModule.prototype, 'callDetailItemTp', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionTpModule.prototype, 'setViewHeaderTp', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], transactionTpModule.prototype, 'setResetViewHeaderTp', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionTpModule.prototype, 'setHeaderIdTp', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionTpModule.prototype, 'setTempId', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionTpModule.prototype, 'setTpItemList', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], transactionTpModule.prototype, 'submitPostTp', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], transactionTpModule.prototype, 'deleteTpTransactionList', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], transactionTpModule.prototype, 'searchHeaderTpPis', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], transactionTpModule.prototype, 'cancelPostTp', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionTpModule.prototype, 'setTabConditionTp', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionTpModule.prototype, 'setPostClickedTp', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], transactionTpModule.prototype, 'setErrorSnNotSameTp', null);
transactionTpModule = __decorate([
    Module
], transactionTpModule);
export default transactionTpModule;
